import { ServiceType } from 'src/xlr-configuration/service-type';
import launchAnimation from '../media/launch-animation.json';
import loadingAnimation from '../media/loading-animation.json';
import trainingAnimation from '../media/training-mode-animation.json';

type LottieAnimation = typeof launchAnimation | typeof loadingAnimation | typeof trainingAnimation;

// TODO: These dynamic animations need to be refactored to either fixed labels or replaced
// with native CSS Animations for maintainability. Emerald is using the ones from a while ago with slight
// modifications
const R10_ANIMATION_LABEL = 'Emerald GX';

export const getLoadingAnimation = (serviceType: ServiceType): LottieAnimation => {
  if (serviceType === ServiceType.EmeraldSellingService) {
    return loadingAnimation;
  }
  if (loadingAnimation.layers[7].t) {
    loadingAnimation.layers[7].t.d.k[0].s.t = R10_ANIMATION_LABEL;
  }
  return loadingAnimation;
};

export const getLaunchAnimation = (serviceType: ServiceType): LottieAnimation => {
  if (serviceType === ServiceType.EmeraldSellingService) {
    return launchAnimation;
  }
  if (launchAnimation.layers[7].t) {
    launchAnimation.layers[7].t.d.k[0].s.t = R10_ANIMATION_LABEL;
  }
  return launchAnimation;
};

export const getTrainingModeAnimation = (serviceType: ServiceType): LottieAnimation => {
  if (serviceType === ServiceType.EmeraldSellingService) {
    return trainingAnimation;
  }
  if (trainingAnimation.layers[8].t) {
    trainingAnimation.layers[8].t.d.k[0].s.t = R10_ANIMATION_LABEL;
  }
  return trainingAnimation;
};
